import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export function EmptyState({ title, description, ctaLabel, ctaTo, icon: Icon }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 px-6 rounded-2xl border border-white/5 bg-[hsl(220_18%_8%)]/60">
      {Icon && (
        <div className="h-14 w-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-4">
          <Icon className="h-6 w-6 text-cyan-300" />
        </div>
      )}
      <h3 className="font-display text-2xl text-white tracking-[0.12em]">{title}</h3>
      <p className="text-white/50 max-w-md mt-2 text-sm">{description}</p>
      {ctaTo && (
        <Link to={ctaTo} className="mt-6">
          <Button className="bg-cyan-400 text-black hover:bg-cyan-300">
            {ctaLabel} <ArrowRight className="ml-1 h-4 w-4" />
          </Button>
        </Link>
      )}
    </div>
  );
}

export function SectionHeading({ eyebrow, title, description, right }) {
  return (
    <div className="flex items-end justify-between gap-3 sm:gap-4 mb-4 sm:mb-6">
      <div className="min-w-0">
        {eyebrow && <div className="font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.28em] sm:tracking-[0.35em] text-cyan-300/80">{eyebrow}</div>}
        <h1 className="font-display text-2xl sm:text-3xl md:text-4xl text-white tracking-[0.04em] sm:tracking-[0.06em] mt-1 break-words leading-[1.05]">{title}</h1>
        {description && <p className="text-white/55 mt-1 max-w-2xl text-[12.5px] sm:text-sm leading-snug">{description}</p>}
      </div>
      {right}
    </div>
  );
}

export function RarityPill({ rarity }) {
  return (
    <span className={`rarity-${rarity} font-mono text-[10px] uppercase tracking-[0.25em] px-2 py-1 rounded-md`} style={{ color: "var(--label)", background: "rgba(0,0,0,0.45)", border: "1px solid var(--edge)" }}>
      {rarity}
    </span>
  );
}
